import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add_col_after",
  "use": "add_col_after-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add_col_after\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 6a1 1 0 00-1 1v4H1a1 1 0 100 2h4v4a1 1 0 102 0v-4h4a1 1 0 100-2H7V7a1 1 0 00-1-1zM24 1a1 1 0 00-1-1h-8a1 1 0 00-1 1v22a1 1 0 001 1h8a1 1 0 001-1V1zm-2 2a1 1 0 00-1-1h-4a1 1 0 00-1 1v18a1 1 0 001 1h4a1 1 0 001-1V3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol